const papers = [
  {
    "authors": ["Shahad P.", "Ebin Deni Raj"],
    "title": "Enhancing model adaptability and transparency: i-MAAR algorithm for non-stationary streaming data analysis",
    "conference": "Knowledge-Based Systems",
    "publisher": "Elsevier",
    "year": 2026
  },
  {
    "authors": ["Ashly Ann Jo", "Ebin Deni Raj", "S. Srinivasalu"],
    "title": "Agent-Based Modelling of the Indian Public Distribution System in AI FORA",
    "conference": "Participatory Modelling and Simulation to Improve AI-based Public Social Services",
    "publisher": "Springer",
    "year": 2026
  },
  {
    "authors": ["Mahesh Sasikumar", "Ashly Ann Jo", "Ebin Deni Raj"],
    "title": "Better AI for Public Good: Participatory Modelling and Simulation in Social Services",
    "conference": "Participatory Modelling and Simulation to Improve AI-based Public Social Services",
    "publisher": "Springer",
    "year": 2026
  },
  {
    "authors": ["S. Palathingal", "Ebin Deni Raj"],
    "title": "Resource-Aware Conditional Cascaded (RACC-SLM) framework for zero-shot intent detection in real-time voice streams",
    "conference": "Computing",
    "publisher": "Springer",
    "year": 2026
  },
  {
    "authors": ["Ashly Ann Jo", "Ebin Deni Raj"],
    "title": "Auditable Credit Scoring: Explainable Models with Stable Rationales on Tabular Data",
    "conference": "International Conference on AI-Driven Smart Systems and Ubiquitous Computing",
    "publisher": "IEEE",
    "year": 2026
  },
  {
    "authors": ["Ebin Deni Raj", "Divya Sindhu Lekha", "Ashly Ann Jo"],
    "title": "Teaching Explainable Machine Learning to Interdisciplinary Learners: A Pedagogical Model for Responsible AI",
    "conference": "Computing Education Research, 18th Annual ACM India Compute Conference",
    "publisher": "ACM",
    "year": 2025
  },
  {
    "authors": ["Ebin Deni Raj", "Divya Sindhu Lekha", "Ashly Ann Jo", "Arun Cyril Jose"],
    "title": "Teaching Explainable Machine Learning to Interdisciplinary Learners: A Pedagogical Model for Responsible AI Education",
    "conference": "Annual ACM India Compute Conference",
    "publisher": "ACM",
    "year": 2025
  },
  {
    "authors": ["Konyala Anish Reddy", "A. Kumar", "S. Maurya", "Mahesh Sasikumar", "Ebin Deni Raj"],
    "title": "Enhancing Air Quality Prediction with Explainable Machine Learning and Deep Learning Models",
    "conference": "International Conference on Responsible, Generative and Explainable AI",
    "publisher": "IEEE",
    "year": 2025
  },
  {
    "authors": ["Ebin Deni Raj"],
    "title": "Emotion Analysis Using Explainability-Driven AI for Enhanced Interpretability",
    "conference": "International Conference on Responsible, Generative and Explainable AI",
    "publisher": "IEEE",
    "year": 2025
  },
  {
    "authors": ["Ebin Deni Raj"],
    "title": "Swin-rsic: remote sensing image classification using a modified swin transformer with explainability",
    "conference": "Earth Science Informatics",
    "publisher": "Springer",
    "year": 2025
  },
  {
    "authors": ["Petra Ahrweiler", "N. Gilbert", "M. Bicket", "A. Sabater Coll", "E. Spaeth", "H. Bashiri", "et al."],
    "title": "Agent-Based Modelling for Public Social Service Distribution",
    "conference": "International Workshop on Multi-Agent Systems and Agent-Based Simulation",
    "publisher": "Springer",
    "year": 2025
  },
  {
    "authors": ["Ashly Ann Jo", "Ebin Deni Raj", "Jayakrushna Sahoo"],
    "title": "Efficiency and performance optimization in large language models through ib fine-tuning",
    "conference": "ACM Transactions on Intelligent Systems and Technology",
    "publisher": "ACM",
    "year": 2025
  },
  {
    "authors": ["A.K. Nair", "S. Coleri", "Jayakrushna Sahoo", "L.R. Cenkeramaddi", "Ebin Deni Raj"],
    "title": "Incentivized federated learning: A survey",
    "conference": "IEEE Transactions on Emerging Topics in Computational Intelligence",
    "publisher": "IEEE",
    "year": 2025
  },
  {
    "authors": ["S. Srinivasalu", "M. Selladurai", "S. Sharma", "G. Perumal", "M. Mathaiyan", "Ashly Ann Jo", "et al."],
    "title": "Social Assessment and Cultural Resistance: The Public Distribution System in Tamil Nadu, India",
    "conference": "Participatory Artificial Intelligence in Public Social Services: From Bias to Better Outcomes",
    "publisher": "Springer",
    "year": 2025
  },
  {
    "authors": ["G. Perumal", "M. Mathaiyan", "Ebin Deni Raj"],
    "title": "The Public Distribution System in Tamil Nadu, India",
    "conference": "Participatory Artificial Intelligence in Public Social Services: From Bias to Better Outcomes",
    "publisher": "Springer",
    "year": 2025
  },
  {
    "authors": ["Subodh Uniyal", "Maitri Deepak Savla", "Ashly Ann Jo", "Ebin Deni Raj"],
    "title": "Transparency in legal AI: Pioneering explainable NLP for enhanced judgement prediction",
    "conference": "Data Science & Exploration in Artificial Intelligence",
    "publisher": "CRC Press",
    "year": 2025
  },
  {
    "authors": ["Ashly Ann Jo", "Ebin Deni Raj", "A. Chakraborty"],
    "title": "MaternaAI: Enhancing Equitable Maternal Healthcare in Kerala with Fairness-Aware and Explainable Learning Models",
    "conference": "",
    "publisher": "",
    "year": 2025
  },
  {
    "authors": ["Mahesh Sasikumar", "Ebin Deni Raj"],
    "title": "Investigating explainability of deep learning models for sequential data on stock price prediction",
    "conference": "Procedia Computer Science",
    "publisher": "Elsevier",
    "year": 2025
  },
  {
    "authors": ["Jeena Thomas", "Ebin Deni Raj"],
    "title": "Improved image dehazing model with color correction transform-based dark channel prior",
    "conference": "The Visual Computer",
    "publisher": "Springer",
    "year": 2024
  },

  {
    "authors": ["Shahad P.", "Ebin Deni Raj"],
    "title": "Interpretability-Based Virtual Drift Detection and Adaptation Algorithm: A Case Study on Tetouan’s Energy Data.",
    "conference": "International Conference on Intelligent Computing and Emerging Communication Technologies (ICEC)",
    "publisher": "IEEE",
    "year": 2024
  },
  {
    "authors": ["Susmera Joseph", "Ashly Ann Jo", "Ebin Deni Raj"],
    "title": "Improving Time Series Forecasting Accuracy with Transformers: A Comprehensive Analysis with Explainability.",
    "conference": "Third International Conference on Electrical, Electronics, Information and Communication Technologies (ICEEICT)",
    "publisher": "IEEE",
    "year": 2024
  },
  {
    "authors": ["Ranjith R.", "Ashly Ann Jo", "Ebin Deni Raj"],
    "title": "Bipol-Driven Bias Analysis in Transformer Models: A Quantitative, Global, and Local Interpretability Approach for Textual Data.",
    "conference": "IEEE 3rd World Conference on Applied Intelligence and Computing (AIC)",
    "publisher": "IEEE",
    "year": 2024
  },
  {
    "authors": ["Ashly Ann Jo", "Ebin Deni Raj", "Angel Susan Vino", "Parvathy V. Menon"],
    "title": "Exploring Explainable AI for Enhanced Depression Prediction in Mental Health.",
    "conference": "First International Conference on Innovations in Communications, Electrical and Computer Engineering (ICICEC)",
    "publisher": "IEEE",
    "year": 2024
  },
  {
    "authors": ["Ijas A.H", "Ashly Ann Jo", "Ebin Deni Raj"],
    "title": "Transparency in Legal AI: Pioneering Explainable NLP for Enhanced Judgement Prediction",
    "conference": "11th International Conference on Advances in Computing and Communications (ICACC)",
    "publisher": "IEEE",
    "year": 2024
  },
  {
    "authors": ["Jeena Thomas", "Ebin Deni Raj"],
    "title": "Improved image dehazing model with color correction transform-based dark channel prior.",
    "conference": "The Visual Computer",
    "publisher": "Springer",
    "year": 2024
  },
  
  
  
  
  {
    "authors": ["Subodh Uniyal", "Maitri D. Savla", "Tushaar", "Ashly Ann Jo", "Ebin Deni Raj"],
    "title": "Transparency in Legal AI: Pioneering Explainable NLP for Enhanced Judgement Prediction",
    "conference": "International Conference on Data Science & Exploration in Artificial Intelligence (CODE-AI)",
    "publisher": "Taylor & Francis",
    "year": 2024
  },
  {
    "authors": ["Ashly Ann Jo", "Ebin Deni Raj"],
    "title": "Ethical Dimensions in Data-Driven Business: Balancing Fairness, Accountability, Transparency, and Explainability",
    "conference": "15th International IEEE Conference On Computing, Communication And Networking Technologies (ICCCNT)",
    "publisher": "IEEE",
    "year": 2024
  },
  {
    "authors": ["Mahesh Sasikumar", "Ebin Deni Raj"],
    "title": "A short survey on Interpretable techniques with Time series data.",
    "conference": "2024 IEEE International Students' Conference on Electrical, Electronics and Computer Science (SCEECS)",
    "pages": "pp. 1-10",
    "publisher": "IEEE",
    "year": 2024
  },
  {
    "authors": ["Ashly Ann Jo", "Caina Rose Paul", "S. Arundhathi Nair", "Jeena Thomas", "Ebin Deni Raj"],
    "title": "Tabular Data Interpretation on COVID-19 Through Explainable Machine Learning.",
    "conference": "International Conference on Emerging Trends and Technologies on Intelligent Systems",
    "pages": "pp. 653-666",
    "publisher": "Springer Nature Singapore",
    "year": 2023,
    "website":"https://link.springer.com/chapter/10.1007/978-981-99-3963-3_49"
  },
  {
    "authors": ["J Bhagya", "Jeena Thomas", "Ebin Deni Raj"],
    "title": "Exploring Explainability and Transparency in Deep Neural Networks: A Comparative Approach.",
    "conference": "2023 7th International Conference on Intelligent Computing and Control Systems (ICICCS)",
    "pages": "pp. 664-669",
    "publisher": "IEEE",
    "year": 2023,
    "website":"https://ieeexplore.ieee.org/document/10142255"
  },
  {
    "authors": ["Ashly Ann Jo", "Ebin Deni Raj"],
    "title": "Post hoc Interpretability: Review on New Frontiers of Interpretable AI.",
    "conference": "Advances in Distributed Computing and Machine Learning: Proceedings of ICADCML 2023",
    "pages": "261-276",
    "publisher": "Springer",
    "year": 2023,
    "website":"https://link.springer.com/chapter/10.1007/978-981-99-1203-2_23"
  },
  {
    "authors": ["Sai Tejashwin Eswarapu", "S. Sesharhri", "Yashwanth Deshaboina", "P. Bhargawa", "Ashly Ann Jo", "Ebin Deni Raj"],
    "title": "Integrated Customer Analytics using Explainability and AutoML for Telecommunications.",
    "conference": "2023 2nd International Conference on Applied Artificial Intelligence and Computing (ICAAIC)",
    "pages": "pp. 228-235",
    "publisher": "IEEE",
    "year": 2023,
    "website":"https://ieeexplore.ieee.org/document/10141019"
  },
  {
    "authors": ["Thiruthuvaraj Rajasekhar", "Ashly Ann Jo", "Ebin Deni Raj"],
    "title": "Explainability to Business: Demystify Transformer Models with Attention-based Explanations.",
    "conference": "2023 2nd International Conference on Applied Artificial Intelligence and Computing (ICAAIC)",
    "pages": "pp. 680-686",
    "publisher": "IEEE",
    "year": 2023,
    "website":"https://ieeexplore.ieee.org/abstract/document/10141005"
  },
  {
    "authors": ["Sheema Madhusudhanan", "Arun Cyril Jose", "Jayakrushna Sahoo", "Reza Malekian"],
    "title": "PRIMϵ: Novel Privacy-Preservation Model With Pattern Mining and Genetic Algorithm.",
    "conference": "IEEE Transactions on Information Forensics and Security",
    "publisher": "IEEE",
    "year": 2023,
    "website": "https://ieeexplore.ieee.org/document/10286086/"
  },
  {
    "authors": ["Akarsh K. Nair", "Jayakrushna Sahoo", "Ebin Deni Raj"],
    "title": "Privacy preserving Federated Learning framework for IoMT based big data analysis using edge computing.",
    "conference": "Computer Standards & Interfaces",
    "publisher":"Elsevier",
    "year": 2023,
    "website": "https://www.sciencedirect.com/science/article/abs/pii/S0920548923000016"
  },
  {
    "authors": ["Akarsh K. Nair", "Ebin Deni Raj", "Jayakrushna Sahoo"],
    "title": "A robust analysis of adversarial attacks on federated learning environments.",
    "conference": "Computer Standards & Interfaces",
    "publisher":"Elsevier",
    "year": 2023,
    "website": "https://www.sciencedirect.com/science/article/abs/pii/S0920548923000041"
  },
  {
    "authors": ["Chinju John", "Jayakrushna Sahoo", "Manu Madhavan", "Oommen K. Mathew"],
    "title": "Convolutional Neural Networks: A Promising Deep Learning Architecture for Biological Sequence Analysis.",
    "conference": "Current Bioinformatics",
    "publisher":"Elsevier",
    "year": 2023,
    "website": "https://www.researchgate.net/publication/369468037_Convolutional_Neural_Networks_A_Promising_Deep_Learning_Architecture_for_Biological_Sequence_Analysis"
  },
  {
    "authors": ["Akarsh K. Nair", "Ebin Deni Raj", "Jayakrushna Sahoo"],
    "title": "An Overview of Artificial Intelligence for Advanced Healthcare Systems.",
    "conference": "Digital Health Transformation with Blockchain and Artificial Intelligence",
    "publisher":"Taylor & Francis",
    "year": 2022,
    "website": "https://www.researchgate.net/publication/359905761_An_Overview_of_Artificial_Intelligence_for_Advanced_Healthcare_Systems"
  },
  {
    "authors": ["Chinju John", "Akarsh K. Nair", "Jayakrushna Sahoo"],
    "title": "Drug Discovery Using Explainable AI Approaches: The Current Scenario.",
    "conference": "Handbook of AI-Based Models in Healthcare and Medicine",
    "publisher": "Taylor & Francis",
    "year": 2024,
    "website": "https://www.taylorfrancis.com/chapters/edit/10.1201/9781003247128-8/overview-artificial-intelligence-advanced-healthcare-systems-akarsh-nair-ebindeni-raj-jayakrushna-sahoo"
  },
  {
    "authors": ["Jisha Mariyam John", "Michele Bellingeri", "Divya Sindhu Lekha", "Davide Cassi", "Roberto Alfieri"],
    "title": "Robustness of Real-World Networks after Weight Thresholding by Strong Link Removal.",
    "conference": "Mathematics",
    "publisher":"MDPI",
    "year": 2024,
    "website": "https://www.preprints.org/manuscript/202402.1674/v1"
  },
  {
        "authors": ["Ashly Ann Jo", "Ebin Deni Raj", "Jayakrushna Sahoo"],
        "title": "Efficiency and Performance Optimization in Large Language Models through IB Fine-Tuning.",
        "conference": "ACM Transactions on Intelligent Systems and Technology",
        "publisher":"ACM",
        "year": 2024
  },

  {
        "authors": ["Mahesh Sasikumar", "Ebin Deni Raj"],
        "title": "Investigating explainability of deep learning models for sequential data on stock price prediction.",
        "conference": "International Conference on Machine Learning and Data Engineering",
        "publisher":"Elsevier",
        "year": 2024
  },

];

export default papers;
